module.exports = __webpack_public_path__ + "static/img/cont49 (1).7aa8ea3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont49 (1).jpg
// module id = KcL/
// module chunks = 0